import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-youtube-video-dialog',
  templateUrl: './youtube-video-dialog.component.html',
  styleUrls: ['./youtube-video-dialog.component.scss']
})
export class YoutubeVideoDialogComponent implements OnInit {

  id = '0JznKjt38Ao';

  constructor() { }

  ngOnInit() {
  }

  onReady(player: YT.Player) {
    player.playVideo();
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/youtube-video-dialog/youtube-video-dialog.component.ts